import { Moment } from 'moment';

export class ChartDataRow {
    constructor(
        public readonly date: Moment,
        public readonly bufferG: number,
        public readonly bufferY: number,
        public readonly bufferR: number,
        public readonly safetyBuffer: number,
        public readonly actionBuffer: number,
        public readonly valueOut: number,
        public readonly valueIn: number,
        public readonly checkedBalance: number,
        public readonly noData: number,
        public readonly balance: number,
        public readonly targetStockLevel: number,
        public readonly packageValue: number,
        public readonly replenishmentTime: number,
        public readonly shelfQuantity: number,
        public readonly actionSafetyBuffer: number,
        public readonly maxQuantity: number,
        public readonly maxBuffer: number,
        public readonly minBuffer: number,

        public readonly action: boolean,
        public readonly season: boolean,
        public readonly vacation: boolean,
        public readonly holiday: boolean,
        public readonly orderDay: boolean,
        public readonly deliveryDay: boolean,
        public readonly bufferGrowFixed: boolean,
        public readonly bufferDecreaseFixed: boolean
    ) {
        
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/chart-data-row.ts